"use client";

import Link from "next/link";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-abis-primary via-blue-900 to-abis-primary">
      <div className="text-center px-4">
        <h1 className="text-9xl font-bold text-white mb-4">404</h1>
        <h2 className="text-3xl font-semibold text-white mb-4">
          Seite nicht gefunden
        </h2>
        <p className="text-white/80 mb-8 max-w-md mx-auto">
          Die von Ihnen gesuchte Seite existiert leider nicht oder wurde
          verschoben.
        </p>
        <div className="flex gap-4 justify-center">
          <Link
            href="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-abis-accent text-white rounded-lg hover:bg-abis-accent/90 transition-colors"
          >
            <Home className="w-5 h-5" />
            Zur Startseite
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Zurück
          </button>
        </div>
      </div>
    </div>
  );
}

